import { Euler, Quaternion, Vector3 } from "three";
import { MathUtils } from "@utils/math";
class ProceduralRecoil {
    lerpAmount;
    minUpwardsRecoil;
    rotationAmount;
    rotationOffset;
    positionOffset;
    /**
     * Class responsible for handling procedurally-generated recoil.
     * @param rotationAmount The amount by which the gun should recoil. Represented in Euler for ease of use.
     * @param kickback How much kickback there should be, meaning how much the gun moves along the Z axis during recoil.
     * @param lerpAmount Controls how slowly the gun will come back to its original position. A higher amount makes the return slower.
     */
    constructor(rotationAmount, minUpwardsRecoil = 0.1, lerpAmount = 0.1) {
        this.lerpAmount = lerpAmount;
        this.minUpwardsRecoil = minUpwardsRecoil;
        this.rotationAmount = rotationAmount;
        this.rotationOffset = new Quaternion();
        this.positionOffset = new Vector3();
    }
    /**
     * Applies recoil or returns from it.
     * Should be called at every logic step.
     * @param bone The bone of an entity to which recoil should be applied.
     */
    step(bone) {
        this.rotationOffset.slerp(new Quaternion(), this.lerpAmount).normalize();
        const currentRotation = bone.quaternion.clone();
        const newRotation = currentRotation.multiply(this.rotationOffset);
        newRotation.normalize();
        bone.quaternion.copy(newRotation);
    }
    /**
     * Trigger recoil. Should be called when an entity shoots.
     */
    recoil() {
        const rotationEuler = new Euler(MathUtils.randRange(this.minUpwardsRecoil, this.rotationAmount.x), MathUtils.randRange(-this.rotationAmount.y, this.rotationAmount.y), MathUtils.randRange(-this.rotationAmount.z, this.rotationAmount.z));
        const recoilAmount = new Quaternion().setFromEuler(rotationEuler);
        this.rotationOffset.multiply(recoilAmount);
    }
}
export { ProceduralRecoil };
